import urlPrefixes from '../../../constants/urlPrefixes';
import createURLComponent from '../createURLComponent';

type TSellerParams = {
  name: string;
  id: number | string;
};

const createSellerNameComponent = (sellerName: string): string => {
  const normalized = createURLComponent(sellerName);
  return normalized || 'verkoper'; // TODO: pass translation for this part
};

const getSellerUrl = (seller: TSellerParams): string =>
  `/${urlPrefixes.seller}/${createSellerNameComponent(seller.name)}/${seller.id}`;

/**
 * create seller part
 */
export default (seller?: TSellerParams): string =>
  seller && Number(seller.id) > 0 && seller.name ? getSellerUrl(seller) : '';
